import React, { useMemo, cloneElement, Children, Fragment } from 'react';

import { mosaiqStyled } from '../../lib';

import { getTyprographyPropsByAvatarSize } from '../../utils';

import { Typography } from '../Typography';

import { Avatar } from '../Avatar';

import { AvatarListProps } from './types';

import { AvatarListContainer } from './AvatarList.styles';

const AvatarList = mosaiqStyled<AvatarListProps, HTMLDivElement>(
  ({ children, size = 'regular', maxCount, innerRef, ...props }) => {
    if (!children) {
      return null;
    }

    const { displayChildren, overflowAvatar, overflowCount } = useMemo(() => {
      let overflowAvatar;

      let overflowCount = 0;

      let displayChildren = Children.toArray(children);

      if (!!maxCount) {
        const childCount = Children.count(children);

        if (childCount > 1 && !!maxCount) {
          overflowCount = childCount > maxCount ? childCount - (maxCount - 1) : 0;

          if (overflowCount > 0) {
            overflowAvatar = displayChildren[maxCount - 1];
          }

          displayChildren = displayChildren.slice(
            0,
            maxCount && childCount > maxCount ? maxCount - 1 : childCount,
          );
        }
      }

      return {
        displayChildren,
        overflowAvatar,
        overflowCount,
      };
    }, [children, maxCount]);

    return (
      <AvatarListContainer ref={innerRef} size={size} {...props}>
        {displayChildren.map((children, i) => (
          <Fragment key={i}>
            {Children.map(children, (child) =>
              cloneElement(child as JSX.Element, {
                size,
              }),
            )}
          </Fragment>
        ))}
        {overflowCount > 0 && !!displayChildren?.length && (
          <Avatar {...(overflowAvatar?.props || {})} size={size} overlay>
            <Typography color="white" {...getTyprographyPropsByAvatarSize(size)}>
              +{overflowCount}
            </Typography>
          </Avatar>
        )}
      </AvatarListContainer>
    );
  },
);

AvatarList.displayName = 'AvatarList';

export default AvatarList;
